<template>
  <div class="card-variant" :class="{ 'card-variant_error': error }">
    <el-divider class="card-variant__divider" />
    <div class="card-variant__top">
      <div class="card-variant__letter" :class="getColor">{{ getLetter }}</div>
      <div class="card-variant__title">{{ percentage }}% of traffic</div>
      <div class="card-variant__close" v-if="isRemovable">
        <el-icon @click="onRemove"><Close /></el-icon>
      </div>
    </div>
    <el-form-item label="Object of testing">
      <el-input
        v-model="titleData"
        :disabled="isDisabled"
        placeholder=""
        @input="onUpdate($event, 'title')"
      />
    </el-form-item>
    <el-form-item label="Unique Variant Key">
      <el-input
        v-model="uniqueData"
        :disabled="isDisabled"
        placeholder=""
        @input="onUpdate($event, 'key')"
      />
    </el-form-item>
  </div>
</template>

<script>
import { Close } from "@element-plus/icons-vue";
import debounce from "lodash.debounce";

export default {
  components: { Close },
  props: {
    title: {
      type: String,
      default: null,
    },
    unique: {
      type: String,
      default: null,
    },
    isRemovable: {
      type: Boolean,
      default: null,
    },
    error: {
      type: Boolean,
      default: null,
    },
    index: {
      type: Number,
      default: 0,
    },
    percentage: {
      type: Number,
      default: 0,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      titleData: this.title,
      uniqueData: this.unique,
    };
  },
  computed: {
    getColor() {
      const colors = ["green", "yellow", "red", "blue", "violet", "gray"];
      return colors[this.index % colors.length] || colors[0];
    },
    getLetter() {
      const letters = ["A", "B", "C", "D", "E", "F"];
      return letters[this.index % letters.length] || letters[0];
    },
  },
  watch: {
    title(val) {
      this.titleData = val;
    },
    unique(val) {
      this.uniqueData = val;
    },
  },
  created() {
    this.onUpdate = debounce(this.onUpdate, 400);
  },
  methods: {
    onRemove() {
      if (!this.isDisabled) this.$emit("remove");
    },
    onUpdate(val, key) {
      this.$emit("update", [val, key]);
    },
  },
};
</script>

<style lang="scss" scoped>
.card-variant {
  &_error {
    .card-variant__title {
      color: #f76141;
    }
  }
  &__divider {
    margin: 16px 0 !important;
  }
  &__top {
    margin-bottom: 8px;
    display: flex;
    align-items: center;
  }
  &__letter {
    display: flex;
    height: 20px;
    padding: 0 8px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
    background: #6db90c;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    color: #fff;
  }
  &__title {
    margin-left: 5px;
    font-size: 13px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
  }
  &__close {
    margin-left: auto;
    cursor: pointer;
  }
  &__input-row {
    margin-top: 15px;
  }

  .green {
    background: #6db90c;
  }
  .yellow {
    background: #f5c828;
  }
  .red {
    background: #f66141;
  }
  .blue {
    background: #3697f1;
  }
  .violet {
    background: #9747ff;
  }
  .gray {
    background: #979797;
  }
}
</style>
